import React from "react";
import {
  Box,
  Skeleton,
  Typography
} from "@mui/material";
import moment from "moment/moment";
import {Event} from "@mui/icons-material";

const BookingReadEndDate = ({
    isLoading,
    dataUpdate
  }) => {

  return (
    <>
      {!isLoading ?
        <Box
          sx={{
            display: 'flex'
          }}
        >
          <Event sx={{mr: '0.5rem'}}/>
          <Typography
            sx={{marginBottom: '0.5rem'}}
          >
            <b>Data de Termino:</b> {moment(new Date(dataUpdate?.date_end)).format('LLL')}
          </Typography>
        </Box>
        :
        <Skeleton
          variant="rounded"
          animation="pulse"
          height={24}
          sx={{marginBottom: '0.5rem'}}
        />
      }
    </>
  )
}

export default BookingReadEndDate